import { render, staticRenderFns } from "./UserDetailCard.vue?vue&type=template&id=78eaf9a4&"
import script from "./UserDetailCard.vue?vue&type=script&lang=js&"
export * from "./UserDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailCard.vue?vue&type=style&index=0&id=78eaf9a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports